module.exports = __webpack_public_path__ + "img/checklist.368d584d.svg";